export default {
  // Navigation
  nav_home: 'Home',
  nav_dashboard: 'Dashboard',
  nav_orders: 'Ordini',
  nav_wallet: 'Portafoglio',
  nav_analytics: 'Analisi',
  nav_referral: 'Referral',
  nav_account: 'Account',
  nav_notifications: 'Notifiche',
  nav_logout: 'Logout',
  nav_login: 'Accedi',
  nav_signup: 'Iscriviti',
  nav_deposit_requests: 'Richieste di deposito',
  nav_withdraw_requests: 'Richieste di prelievo',
  nav_support_ticket: 'Ticket di supporto',
  nav_system_logs: 'Log di sistema',
  nav_announcements: 'Annunci',
  nav_activity_logs: 'Log di attività',
  nav_settings: 'Impostazioni',
  nav_section_main: 'Principale',
  nav_user_active: 'Attivo ora',
  nav_more: 'Altro',
  nav_logout_confirm: 'Sei sicuro di voler uscire?',
  nav_language: 'Lingua',

  // Dashboard
  dashboard_welcome: 'Bentornato',
  dashboard_total_earnings: 'Guadagni totali',
  dashboard_pending_orders: 'Ordini in sospeso',
  dashboard_completed_orders: 'Ordini completati',
  dashboard_commission_rate: 'Tasso di commissione',
  dashboard_quick_actions: 'Azioni rapide',
  dashboard_recent_orders: 'Ordini recenti',
  dashboard_recent_activity: 'Attività recente',
  dashboard_wallet_balance: 'Saldo portafoglio',
  dashboard_deposit: 'Deposita',
  dashboard_withdraw: 'Preleva',
  dashboard_view_all: 'Vedi tutto',
  greeting_morning: 'Buongiorno',
  greeting_afternoon: 'Buon pomeriggio',
  greeting_evening: 'Buonasera',
  dashboard_greeting_desc: 'Tieni traccia dei tuoi guadagni, completa gli ordini e gestisci il tuo account in un unico posto. Il tuo percorso verso il successo continua qui!',

  // Dashboard Stats
  stats_available_balance: 'Saldo disponibile',
  stats_total_withdrawn: 'Totale prelevato',
  stats_total_deposit: 'Totale depositato',
  stats_pending_orders: 'Ordini in sospeso',
  stats_orders_suffix: ' ordini',
  stats_task_earnings: 'Guadagni compiti',
  stats_lifetime_earning: 'Guadagni totali',

  // Orders
  orders_title: 'I miei ordini',
  orders_all: 'Tutti gli ordini',
  orders_pending: 'In sospeso',
  orders_completed: 'Completato',
  orders_cancelled: 'Annullato',
  orders_order_id: 'ID Ordine',
  orders_platform: 'Piattaforma',
  orders_amount: 'Importo',
  orders_commission: 'Commissione',
  orders_status: 'Stato',
  orders_date: 'Data',
  orders_no_orders: 'Nessun ordine trovato',
  orders_step_1: 'Revisione dei dettagli del prodotto',
  orders_step_2: 'Verifica delle informazioni sull\'ordine',
  orders_step_3: 'Connessione alla piattaforma',
  orders_step_4: 'Invio della promozione',
  orders_step_5: 'Indicizzazione SEO',
  orders_step_6: 'Aumento della visibilità',
  orders_step_7: 'Finalizzazione e conferma',
  orders_btn_optimize: 'Ottimizza ordine',
  orders_btn_claim_commission: 'Richiedi commissione',
  orders_btn_task_completed: 'Attività completata',
  orders_price_label: 'Prezzo dell\'ordine',
  orders_commission_rate_label: 'Tasso di commissione',

  // Wallet
  wallet_title: 'Il mio portafoglio',
  wallet_available_balance: 'Saldo disponibile',
  wallet_pending_balance: 'Saldo in sospeso',
  wallet_total_withdrawn: 'Totale prelevato',
  wallet_deposit_now: 'Deposita ora',
  wallet_withdraw_now: 'Preleva ora',
  wallet_transaction_history: 'Cronologia transazioni',
  wallet_deposit_history: "Deposit History",
  wallet_withdrawal_history: 'Cronologia prelievi',
  wallet_deposit_desc: "Aggiungi denaro al tuo portafoglio utilizzando i metodi di pagamento disponibili.",
  wallet_no_deposits: "Nessun deposito trovato.",
  wallet_withdraw_history: "Cronologia prelievi",
  wallet_withdraw_desc: "Preleva denaro dal tuo portafoglio.",
  wallet_no_withdrawals: "Nessun prelievo trovato.",
  wallet_no_withdrawals_desc: "Non hai ancora effettuato alcun prelievo.",
  withdrawal_restricted_title: 'Prelievo limitato',
  withdrawal_restricted_message: 'I prelievi non sono attualmente disponibili per il tuo account. Contatta l\'assistenza clienti per ulteriori informazioni.',

  // Analytics
  analytics_title: 'Analisi',
  analytics_earnings_overview: 'Panoramica guadagni',
  analytics_platform_breakdown: 'Ripartizione piattaforma',
  analytics_performance_metrics: 'Metriche di performance',
  analytics_top_products: 'Prodotti top',
  analytics_this_month: 'Questo mese',
  analytics_last_month: 'Mese scorso',
  analytics_total_revenue: 'Entrate totali',
  analytics_avg_order_value: 'Valore medio ordine',

  // Referral
  referral_title: 'Programma Referral',
  referral_your_code: 'Il tuo codice referral',
  referral_copy_code: 'Copia codice',
  referral_share_link: 'Condividi link',
  referral_total_referrals: 'Totale referral',
  referral_active_referrals: 'Referral attivi',
  referral_referral_earnings: 'Guadagni referral',
  referral_invite_friends: 'Invita amici',

  // Account
  account_title: 'Impostazioni account',
  account_profile: 'Profilo',
  account_security: 'Sicurezza',
  account_notifications: 'Notifiche',
  account_kyc: 'Verifica KYC',
  account_phone: 'Numero di telefono',
  account_two_factor: 'Autenticazione a due fattori',
  account_save_changes: 'Salva modifiche',
  account_cancel: 'Annulla',

  // Auth & Common
  auth_email: 'Email',
  auth_password: 'Password',
  auth_confirm_password: 'Conferma password',
  auth_forgot_password: 'Password dimenticata?',
  auth_remember_me: 'Ricordami',
  auth_login_button: 'Accedi',
  auth_signup_button: 'Iscriviti',
  auth_already_have_account: 'Hai già un account?',
  auth_dont_have_account: "Non hai un account?",
  auth_reset_password: 'Reimposta password',
  auth_verify_email: 'Verifica email',
  auth_live_platform: 'Piattaforma live',
  auth_security_verification: 'Verifica di sicurezza',
  auth_captcha_refresh: 'Aggiorna',
  auth_captcha_placeholder: 'Risultato',
  auth_captcha_error: 'Somma errata, riprova',
  auth_branding_title: 'Trasforma le promozioni in',
  auth_branding_highlight_prefix: '',
  auth_branding_highlight: 'Guadagni Reali',
  auth_branding_desc: 'Unisciti a migliaia di promotori che guadagnano commissioni giornaliere dai migliori marchi di e-commerce al mondo.',
  auth_sign_in_to_account: 'Accedi al tuo account {{system_name}}',
  auth_email_placeholder: 'tu@esempio.com',
  auth_password_placeholder: 'Inserisci la tua password',
  auth_signing_in: 'Accesso in corso...',
  auth_free_to_join: 'L\'iscrizione è gratuita',
  auth_signup_branding_title: 'Inizia a guadagnare',
  auth_signup_branding_highlight: 'Fin dal primo giorno',
  auth_signup_branding_desc: 'Nessuna esperienza richiesta. Iscriviti in 2 minuti e inizia a completare compiti per i top brand di e-commerce.',
  auth_how_it_works: 'Come funziona',
  auth_signup_desc: 'Unisciti a {{system_name}} e inizia a guadagnare commissioni oggi stesso — è gratis!',
  auth_step_1: 'Crea il tuo account gratuito',
  auth_step_2: 'Sfoglia e accetta compiti',
  auth_step_3: 'Completa e guadagna commissioni',
  auth_signup_step_1_title: 'Crea account',
  auth_signup_step_1_desc: 'Inizia il tuo viaggio',
  auth_signup_step_2_title: 'Completa compiti',
  auth_signup_step_2_desc: 'Guadagna commissioni giornaliere',
  auth_signup_step_3_title: 'Preleva fondi',
  auth_signup_step_3_desc: 'Pagamenti veloci e sicuri',
  auth_benefit_1_title: 'Sicuro e affidabile',
  auth_benefit_1_desc: 'Sicurezza di livello bancario per i tuoi guadagni',
  auth_benefit_2_title: 'Pagamenti istantanti',
  auth_benefit_2_desc: 'Preleva i guadagni entro 24 ore',
  auth_benefit_3_title: 'Comunità globale',
  auth_benefit_3_desc: 'Unisciti a oltre 12.000 promotori attivi',
  auth_benefit_4_title: 'Supporto 24/7',
  auth_benefit_4_desc: 'Ricevi aiuto ogni volta che ne hai bisogno',
  auth_strength_weak: 'Debole',
  auth_strength_fair: 'Sufficiente',
  auth_strength_good: 'Buona',
  auth_strength_strong: 'Forte',
  auth_password_strength: 'Forza password: {{strength}}',
  auth_social_proof: 'Unisciti a oltre {{count}} persone che guadagnano',
  auth_passwords_match: 'Le password coincidono',
  auth_creating_account: 'Creazione account...',
  auth_phone_number: 'Numero di telefono',
  auth_phone_optional: '(Opzionale)',
  auth_phone_placeholder: 'Il tuo numero di telefono',
  auth_full_name: 'Nome completo',
  auth_full_name_placeholder: 'Mario Rossi',
  auth_password_min_chars: 'Almeno 8 caratteri',
  auth_confirm_password_placeholder: 'Ripeti la tua password',
  auth_agree_to: 'Accetto i',
  auth_terms_of_service: 'Termini di Servizio',
  auth_privacy_policy: 'Informativa sulla Privacy',
  auth_and: 'e la',
  auth_create_free_account: 'Crea account gratuito',

  common_loading: 'Caricamento...',
  common_save: 'Salva',
  common_cancel: 'Annulla',
  common_delete: 'Elimina',
  common_edit: 'Modifica',
  common_view: 'Visualizza',
  common_search: 'Cerca',
  common_filter: 'Filtra',
  common_export: 'Esporta',
  common_import: 'Importa',
  common_submit: 'Invia',
  common_close: 'Chiudi',
  common_confirm: 'Conferma',
  common_success: 'Successo',
  common_error: 'Errore',
  common_warning: 'Attenzione',
  common_announcement: 'Annuncio',

  val_full_name_required: 'Il nome completo è obbligatorio',
  val_email_required: 'L\'email è obbligatoria',
  val_password_required: 'La password è obbligatoria',
  val_password_min: 'La password deve avere almeno 8 caratteri',
  val_passwords_dont_match: 'Le password non coincidono',
  security_pin_6_err: 'Il PIN deve essere di esattamente 6 cifre.',
  security_pin_digit_err: 'Il PIN deve contenere solo cifre.',
  val_agree_terms: 'Devi accettare i termini',
  val_conn_error: 'Errore di connessione. Riprova.',

  // Homepage
  home_hero_title: 'Guadagna commissioni dalle migliori piattaforme di e-commerce',
  home_hero_subtitle: 'Unisciti a migliaia di utenti che guadagnano commissioni giornaliere da Walmart, eBay e AliExpress',
  home_get_started: 'Inizia ora',
  home_learn_more: 'Scopri di più',
  home_how_it_works: 'Come funziona',
  home_features: 'Caratteristiche',
  home_why_choose_us: 'Perché sceglierci',
  home_features_title: 'Funzionalità potenti',
  home_features_subtitle: 'Tutto ciò di cui hai bisogno per iniziare a guadagnare online. Costruito pensando al tuo successo.',
  home_commission_tiers: 'Livelli di commissione',
  home_testimonials: 'Cosa dicono i nostri utenti',
  home_faq: 'Domande frequenti',
  home_cta_title: 'Pronto per iniziare a guadagnare?',
  home_cta_subtitle: 'Unisciti alla nostra comunità oggi e inizia a guadagnare commissioni',
  home_trusted_partner: 'Piattaforme partner affidabili',
  home_secure_platform: 'Piattaforma sicura',
  home_instant_payouts: 'Pagamenti istantanei',
  home_active_users: 'Utenti attivi',
  home_paid_out: 'Pagati',
  home_total_paid_out: 'Totale pagato',
  home_user_rating: 'Valutazione utenti',
  home_countries: 'Paesi',
  home_commission_badge: 'Potenziale di guadagno',
  home_commission_title: 'Tassi di commissione',
  home_commission_desc: 'Un saldo più alto sblocca migliori tassi di commissione. Ogni sessione assegna esattamente 25 ordini — completa fino a 4 sessioni al giorno per massimizzare i guadagni.',
  home_tier_popular: 'Più popolare',
  home_tier_commission_per_order: 'Commissione per ordine',
  home_tier_earn_examples: 'Esempi di guadagno:',
  home_tier_order: 'ordine',
  home_tier_batch_earn: 'Guadagno per lotto da 25 ordini:',
  home_tier_daily_potential: 'Potenziale giornaliero (4 lotti × 25 ordini)',
  home_tier_max_daily: 'Fino a 100 ordini al giorno',
  home_tier_benefit_1: '25 ordini per lotto',
  home_tier_benefit_2: 'Massimo 4 lotti al giorno',
  home_tier_benefit_3: 'Accredito commissione istantaneo',
  home_tier_above: 'Sopra',
  home_tier_no_tiers: 'Nessun livello di commissione trovato.',

  // Comparison Section
  home_compare_badge: 'La differenza',
  home_compare_title: 'Perché siamo migliori',
  home_compare_subtitle: 'Confronta la nostra piattaforma con i tradizionali lavori part-time e scopri perché migliaia di persone ci scelgono.',
  home_compare_feature: 'Caratteristica',
  home_compare_traditional: 'Lavori tradizionali',
  home_compare_our_platform: 'La nostra piattaforma',
  home_compare_f1: 'Flessibilità',
  home_compare_f1_trad: 'Orari fissi',
  home_compare_f1_our: 'Lavora quando e dove vuoi',
  home_compare_f2: 'Pagamenti',
  home_compare_f2_trad: 'Mensili o quindicinali',
  home_compare_f2_our: 'Istantanei / In giornata',
  home_compare_f3: 'Requisiti',
  home_compare_f3_trad: 'Esperienza/CV/Colloquio',
  home_compare_f3_our: 'Nessuno - Solo uno smartphone',
  home_compare_f4: 'Crescita',
  home_compare_f4_trad: 'Aumenti annuali fissi',
  home_compare_f4_our: 'Crescita illimitata basata sui livelli',

  // Testimonials
  home_testi_badge: 'Storie di successo',
  home_testi_title: 'Scelto da migliaia di persone',
  home_testi_subtitle: 'Ascolta la nostra comunità globale di promotori che hanno trasformato il loro reddito.',
  home_testi_no_stories: 'Nessuna storia di successo ancora disponibile.',
  home_testi_total_earned: 'Totale guadagnato',
  home_testi_time_period: 'Periodo di tempo',
  home_testi_verified: 'Utente verificato',
  home_testi_avg_rating: 'Valutazione media',
  home_testi_satisfaction_rate: 'Tasso di soddisfazione',
  home_testi_support_available: 'Supporto disponibile',

  // FAQ
  home_faq_badge: 'Supporto',
  home_faq_title: 'Domande comuni',
  home_faq_subtitle: 'Tutto ciò che devi sapere su come iniziare e guadagnare.',
  home_faq_no_data: 'Nessuna domanda trovata.',

  // Trust Bar
  home_trust_badge: 'Fiducia globale',
  home_trust_title: 'Scelto dai marchi leader',
  home_trust_desc: 'Collaboriamo con le più grandi piattaforme di e-commerce al mondo per fornire servizi di promozione verificati.',

  // Feature Section
  feature_1_title: 'Pagamenti istantanei',
  feature_1_desc: 'Ricevi i tuoi guadagni accreditati immediatamente dopo il completamento dell\'ordine. Preleva in qualsiasi momento senza ritardi.',
  feature_1_detail_1: 'Accredito commissione in tempo reale',
  feature_1_detail_2: 'Molteplici opzioni di prelievo',
  feature_1_detail_3: 'Nessuna soglia minima',
  feature_2_title: 'Piattaforma sicura',
  feature_2_desc: 'La crittografia di livello bancario protegge i tuoi dati e i tuoi guadagni. Scelto da migliaia di utenti in tutto il mondo.',
  feature_2_detail_1: 'Crittografia SSL abilitata',
  feature_2_detail_2: 'Autenticazione a due fattori',
  feature_2_detail_3: 'Audit di sicurezza regolari',
  feature_2_detail_4: 'Privacy dei dati garantita',
  feature_3_title: 'Orari flessibili',
  feature_3_desc: 'Lavora quando vuoi, ovunque tu sia. Completa gli ordini al tuo ritmo senza un programma fisso.',
  feature_3_detail_1: 'Nessun orario di lavoro fisso',
  feature_3_detail_2: 'Lavora da ovunque',
  feature_3_detail_3: 'Scegli il tuo ritmo',
  feature_3_detail_4: 'Disponibilità nel weekend',
  feature_4_title: 'Guadagni progressivi',
  feature_4_desc: 'Sblocca tassi di commissione più elevati man mano che completi più ordini. Aumenta le tue entrate con ogni aggiornamento di livello.',
  feature_4_detail_1: 'Tassi di commissione basati sui livelli',
  feature_4_detail_2: 'Aggiornamenti di livello automatici',
  feature_4_detail_3: 'Premi per la performance',
  feature_5_title: 'Piattaforma globale',
  feature_5_desc: 'Lavora con marchi internazionali da qualsiasi parte del mondo. Supporto multi-valuta incluso.',
  feature_5_detail_1: 'Disponibile in tutto il mondo',
  feature_5_detail_2: 'Supporto multi-valuta',
  feature_5_detail_3: 'Metodi di pagamento locali',
  feature_6_title: 'Supporto 24/7',
  feature_6_desc: 'Il nostro team di supporto dedicato è sempre pronto ad aiutarti. Ottieni assistenza tramite chat dal vivo, e-mail o telefono.',
  feature_6_detail_1: 'Chat dal vivo disponibile',
  feature_6_detail_2: 'Supporto e-mail 24/7',
  feature_6_detail_3: 'Assistenza telefonica',
  feature_6_detail_4: 'FAQ completa',
  feature_7_title: 'Programma Referral',
  feature_7_desc: 'Guadagna entrate extra invitando amici. Ottieni commissioni a vita dai guadagni dei tuoi referral.',
  feature_7_detail_1: 'Guadagni referral a vita',
  feature_7_detail_2: 'Referral illimitati',
  feature_7_detail_3: 'Strumenti di condivisione facili',
  feature_7_detail_4: 'Incentivi bonus',
  feature_8_title: 'Multi-valuta',
  feature_8_desc: 'Supporto per le principali valute e metodi di pagamento. Scegli quello che funziona meglio per te.',
  feature_8_detail_1: 'Supporto USD, EUR, GBP',
  feature_8_detail_2: 'Bonifico bancario disponibile',
  feature_8_detail_3: 'Integrazione e-wallet',
  feature_8_detail_4: 'Opzioni cripto in arrivo',
  feature_9_title: 'Notifiche Istantanee',
  feature_9_desc: 'Rimani aggiornato con avvisi in tempo reale per nuovi ordini, guadagni e attività dell\'account.',
  feature_9_detail_1: 'Notifiche push',
  feature_9_detail_2: 'Avvisi e-mail',
  feature_9_detail_3: 'Aggiornamenti SMS',
  feature_9_detail_4: 'Messaggi in-app',

  // Home Page Additional Sections
  home_how_it_works_badge: 'Processo semplice',
  home_how_it_works_title: 'Come funziona',
  home_how_it_works_subtitle: 'Inizia a guadagnare in 4 semplici passaggi. Nessuna esperienza richiesta, basta seguire il processo e vedere crescere i tuoi guadagni.',
  home_cta_ready_title: 'Pronto per iniziare il tuo viaggio?',
  home_cta_ready_desc: 'Unisciti a migliaia di utenti che stanno già guadagnando ogni giorno. La tua prima commissione è a pochi minuti di distanza!',
  home_cta_avg_time: 'Tempo medio per il primo guadagno:',
  home_cta_15_mins: '15 minuti',
  home_cta_new_users: 'Nuovi utenti oggi:',

  // CTA Section (Premium)
  home_cta_limit_spots: 'Posti limitati disponibili questo mese',
  home_cta_main_title: 'Inizia a fare soldi',
  home_cta_today: 'Oggi stesso!',
  home_cta_main_desc: 'Unisciti a migliaia di utenti che già guadagnano commissioni giornaliere. Nessuna esperienza, orari flessibili, pagamenti istantanei. La tua libertà finanziaria inizia qui.',
  home_cta_spots_remaining: 'Posti rimanenti',
  home_cta_new_users_today: 'Nuovi utenti oggi',
  home_cta_create_account: 'Crea account gratuito',
  home_cta_sign_in: 'Accedi',
  home_cta_secure: 'Sicuro al 100%',
  home_cta_payouts: 'Prelievi in 24-48 ore',
  home_cta_rating: 'Valutazione 4.9/5',
  home_cta_active_users: 'Utenti attivi',
  home_cta_total_paid: 'Totale pagato',
  home_cta_orders_done: 'Attività completate',
  home_cta_satisfaction: 'Soddisfazione',
  home_cta_guarantee_title: 'Garanzia di rimborso',
  home_cta_guarantee_desc: 'Non sei soddisfatto? Ricevi indietro il tuo deposito entro 7 giorni',

  // Footer Branding & Extras
  footer_brand_desc: 'La piattaforma leader mondiale nella promozione dell\'e-commerce. Unisciti alla nostra rete globale di promotori oggi stesso e inizia a guadagnare commissioni dai migliori marchi.',
  footer_ssl_secure: 'SSL Protetto',
  footer_aes_256: 'Crittografia AES-256',
  footer_cookie_policy: 'Politica sui Cookie',
  footer_disclaimer: 'Esclusione di responsabilità',
  footer_all_rights: 'Tutti i diritti riservati.',

  // Announcements
  announcement_withdrawal_delay_title: 'Ritardo nell\'elaborazione dei prelievi',
  announcement_withdrawal_delay_summary: 'I prelievi possono richiedere fino a 72 ore a causa dell\'elevato volume. Si prega di pianificare di conseguenza.',
  announcement_date_june_14: '14 giugno 2025',

  // How It Works Steps
  step_1_title: 'Iscriviti',
  step_1_desc: 'Bastano meno di 2 minuti per creare il tuo account.',
  step_1_detail_1: 'Inserisci le tue informazioni di base',
  step_1_detail_2: 'Verifica il tuo indirizzo email',
  step_1_detail_3: 'Proteggi il tuo account',
  step_1_detail_4: 'Accesso istantaneo alla dashboard',
  step_2_title: 'Scegli il compito',
  step_2_desc: 'Scegli tra i compiti di promozione disponibili.',
  step_2_detail_1: 'Filtra per piattaforma',
  step_2_detail_2: 'Vedi i tassi di commissione',
  step_2_detail_3: 'Accetta più compiti',
  step_2_detail_4: 'Aggiornamenti dei compiti in tempo reale',
  step_3_title: 'Completa il compito',
  step_3_desc: 'Completa i compiti secondo le istruzioni.',
  step_3_detail_1: 'Istruzioni facili da seguire',
  step_3_detail_2: 'Invio compiti veloce',
  step_3_detail_3: 'Verifica automatica',
  step_3_detail_4: 'Interfaccia mobile-friendly',
  step_4_title: 'Guadagna e preleva',
  step_4_desc: 'Ricevi il pagamento per ogni compito completato.',
  step_4_detail_1: 'Tracciamento guadagni in tempo reale',
  step_4_detail_2: 'Soglia minima di prelievo bassa',
  step_4_detail_3: 'Molteplici metodi di pagamento',
  step_4_detail_4: 'Supporto prelievi 24/7',

  // Redesigned Footer
  footer_stay_loop_title: 'Rimani aggiornato',
  footer_stay_loop_desc: 'Ricevi gli ultimi aggiornamenti, consigli e offerte esclusive direttamente nella tua casella di posta.',
  footer_subscribe: 'Iscriviti',
  footer_subscribe_placeholder: 'Inserisci il tuo indirizzo e-mail',
  footer_trusted_secure: 'AFFIDABILE E SICURO:',
  footer_ssl_secured: 'Sicurezza SSL',
  footer_ssl_secured_desc: 'SSL a 256 bit',
  footer_aes_encryption: 'Crittografia AES-256',
  footer_aes_encryption_desc: 'Livello bancario',
  footer_kyc_compliant: 'Conforme KYC',
  footer_kyc_compliant_desc: 'Verificato',
  footer_gdpr_compliant: 'Conforme GDPR',
  footer_gdpr_compliant_desc: 'Dati Protetti',
  footer_iso_certified: 'ISO 27001',
  footer_iso_certified_desc: 'Certificato',
  footer_platform: 'PIATTAFORMA',
  footer_support: 'SUPPORTO',
  footer_legal: 'LEGALE',
  footer_help_center: 'Centro assistenza',
  footer_contact_us: 'Contattaci',
  footer_payments_label: 'Pagamenti:',
  home_live_activity_title: 'Attività della piattaforma dal vivo',
  home_recent_activity_title: 'Attività recente',
  home_total_commissions_paid: 'Totale commissioni pagate',
  home_active_users_online: 'Utenti attivi online',
  home_tasks_completed_today: 'Attività completate oggi',
  account_security_tips_title: 'Raccomandazioni di Sicurezza',
  account_security_tips_desc: 'Migliora la protezione del tuo account seguendo queste semplici best practice.',
  tip_password_title: 'Password Sicura',
  tip_password_desc: 'Usa una combinazione di lettere, numeri e simboli per garantire che il tuo account rimanga sicuro.',
  tip_two_factor_title: 'Verifica dell\'Identità',
  tip_two_factor_desc: 'Mantieni aggiornate le tue informazioni di contatto per ricevere notifiche di sicurezza importanti.',
  tip_logout_title: 'Disconnetti Regolarmente',
  tip_logout_desc: 'Disconnettiti sempre dal tuo account quando utilizzi computer pubblici o condivisi.',
  tip_sharing_title: 'Non Condividere mai l\'Accesso',
  tip_sharing_desc: 'Il nostro team di supporto non ti chiederà mai la password. Non condividere mai le tue credenziali con nessuno.',

  // Richieste d\'Ordine
  order_requests_title: 'Richieste d\'Ordine',
  order_requests_desc: 'Invia una richiesta per una nuova attività o un ordine personalizzato. L\'amministratore esaminerà e assegnerà le attività in base alla tua richiesta.',
  order_requests_new_btn: 'Richiedi Nuovo Ordine',
  order_requests_table_id: 'ID Richiesta',
  order_requests_table_data: 'Dettagli Richiesta',
  order_requests_table_status: 'Stato',
  order_requests_table_date: 'Inviato il',
  order_requests_table_actions: 'Azioni',
  order_requests_cancel: 'Annulla',
  order_requests_cancel_confirm: 'Sei sicuro di voler annullare questa richiesta d\'ordine?',
  order_requests_cancel_success: 'Richiesta d\'ordine annullata con successo.',
  order_requests_create_success: 'Richiesta d\'ordine inviata con successo.',
  order_requests_modal_title: 'Invia Nuova Richiesta d\'Ordine',
  order_requests_modal_desc: 'Fornisci informazioni dettagliate sull\'ordine che desideri richiedere.',
  order_requests_field_data: 'Dati Richiesta d\'Ordine',
  order_requests_field_placeholder: 'es. Vorrei richiedere un ordine personalizzato per il Pacchetto Premium.',
  order_requests_btn_submit: 'Invia Richiesta',
  order_requests_btn_submitting: 'Invio...',
  order_requests_empty: 'Nessuna richiesta d\'ordine trovata.',
  order_requests_status_pending: 'In attesa',
  order_requests_status_approved: 'Approvato',
  order_requests_status_rejected: 'Rifiutato',
  order_requests_status_cancelled: 'Annullato',
  order_requests_terms_title: 'Termini dell\'Ordine Vincolanti',
  order_requests_term_1: 'I nuovi ordini saranno assegnati entro 24-48 ore dall\'approvazione.',
  order_requests_term_2: 'Una volta rilasciati, gli ordini non possono essere annullati, messi in pausa o modificati.',
  order_requests_term_3: 'Tutti gli ordini assegnati devono essere completati prima di effettuare un prelievo.',
  order_requests_term_4: 'La mancata completazione degli ordini può influire sulla reputazione del tuo account.',
  order_requests_term_5: 'Questa richiesta è definitiva e non può essere revocata dopo l\'invio.',
  order_requests_policy_title: 'Politica di Non Annullamento',
  order_requests_policy_desc: 'Inviando questa richiesta, riconosci che il nuovo lotto di ordini è irrevocabile. Una volta confermato dal nostro sistema, non sarà consentita alcuna cancellazione, modifica o rimborso in nessuna circostanza.',
  order_requests_accept_terms: 'Ho letto e comprendo pienamente i termini sopra indicati. Riconosco che, una volta inviata, questa richiesta d\'ordine non può essere annullata o modificata, e accetto di completare tutti gli ordini assegnati.',

  // Orders Page (New Sections)
  orders_withdrawal_policy: 'Politica di Prelievo',
  orders_unlock_req: 'Requisiti di Sblocco',
  orders_unlock_desc: 'Completa il tuo primo lotto di {{count}} ordini per sbloccare permanentemente i prelievi. Questo requisito una tantum garantisce l\'integrità della piattaforma e previene gli abusi.',
  orders_daily_limits: 'Limiti Giornalieri di Ordini',
  orders_daily_limit_1: '{{count}} ordini per lotto — devi completarli tutti prima di richiederne un altro',
  orders_daily_limit_2: 'Massimo {{count}} lotti al giorno ({{total}} ordini/giorno)',
  orders_comm_rates: 'Tassi di Commissione',
  orders_comm_rates_desc: 'I tassi sono determinati dalla piattaforma e dal saldo attuale del tuo portafoglio:',
  orders_payout_timeline: 'Tempi di Pagamento',
  orders_payout_desc: 'I prelievi vengono elaborati entro 24-48 ore. I bonifici bancari possono richiedere 3-5 giorni lavorativi. I prelievi in criptovalute sono istantanei.',
  orders_processing_fee: 'Una commissione di elaborazione del {{fee}}% si applica a tutti i prelievi per coprire i costi di transazione.',
  orders_tips_title: 'Consigli per il Successo',
  orders_tips_1: 'Completa gli ordini quotidianamente per creare slancio e massimizzare i guadagni',
  orders_tips_2: 'Rimani sulla pagina durante l\'elaborazione per garantire il corretto completamento',
  orders_tips_3: 'Controlla regolarmente il tuo portafoglio per monitorare la crescita delle commissioni',
  orders_tips_4: 'Invita amici per guadagnare commissioni bonus sui loro ordini',
  orders_tips_5: 'Contatta subito l\'assistenza in caso di problemi',
  orders_batch_approx: '{{count}} ordini/lotto × media ${{avg}} = circa ${{total}} per lotto',

  // Settings
  settings_page_title: 'Impostazioni',
  settings_page_desc: 'Gestisci la tua sicurezza, privacy e preferenze',
  settings_kyc_label: 'Verifica KYC',
  settings_kyc_desc: 'Verifica dell\'identità',
  settings_security_label: 'Sicurezza',
  settings_security_desc: 'Gestione password',
  settings_language_label: 'Lingua',
  settings_language_desc: 'Preferenze regionali',

  // Support
  support_btn_send: 'Invia risposta',
  support_edit_message: 'Modifica messaggio',
  support_delete_message: 'Elimina messaggio',
  support_delete_confirm: 'Sei sicuro di voler eliminare questo messaggio?',
  support_message_updated: 'Messaggio aggiornato con successo',
  support_message_deleted: 'Messaggio eliminato con successo',
  support_err_already_read: 'Impossibile modificare un messaggio dopo che è stato visualizzato.',
  // Modal di deposito
  deposit_modal_title_method: "Seleziona il metodo di pagamento",
  deposit_modal_title_gateway: "Seleziona il portafoglio crypto",
  deposit_modal_title_plan: "Seleziona il piano di deposito",
  deposit_modal_title_details: "Dettagli del deposito",
  deposit_modal_step_method: "Metodo",
  deposit_modal_step_gateway: "Portafoglio",
  deposit_modal_step_plan: "Piano",
  deposit_modal_step_details: "Dettagli",
  deposit_modal_credit_card: "Carta di credito / debito",
  deposit_modal_bank_transfer: "Bonifico bancario",
  deposit_modal_ewallet: "Portafoglio elettronico",
  deposit_modal_digital_currency: "Valuta digitale",
  deposit_modal_not_available: "Non disponibile nella tua regione",
  deposit_modal_available_recommended: "Disponibile — Consigliato",
  deposit_modal_back_to_method: "Torna ai metodi di pagamento",
  deposit_modal_back_to_gateway: "Torna alla lista portafogli",
  deposit_modal_back_to_plan: "Torna ai piani",
  deposit_modal_digital_selected: "Valuta digitale selezionata",
  deposit_modal_digital_hint: "Scegli il tuo portafoglio crypto per ricevere l'indirizzo e le istruzioni.",
  deposit_modal_loading_wallets: "Caricamento portafogli...",
  deposit_modal_no_wallets: "Nessun portafoglio crypto disponibile.",
  deposit_modal_loading_plans: "Caricamento piani...",
  deposit_modal_no_plans: "Nessun piano di deposito disponibile al momento.",
  deposit_modal_duration: "Durata",
  deposit_modal_amounts_profits: "Importi e profitti",
  deposit_modal_amount_label: "Importo",
  deposit_modal_profit_label: "Profitto",
  deposit_modal_benefits: "Vantaggi",
  deposit_modal_continue: "Continua",
  deposit_modal_transfer_details: "Dettagli del trasferimento per {{name}}",
  deposit_modal_deposit_amount: "Importo del deposito",
  deposit_modal_amount_fixed: "Importo fisso in base al piano selezionato",
  deposit_modal_txn_id: "ID transazione",
  deposit_modal_txn_optional: "(Opzionale)",
  deposit_modal_txn_placeholder: "es. 0x1a2b3c4d...",
  deposit_modal_screenshot: "Screenshot",
  deposit_modal_upload_proof: "Carica prova di pagamento",
  deposit_modal_upload_hint: "PNG, JPG, JPEG — Max 5MB",
  deposit_modal_comments: "Commenti",
  deposit_modal_comments_placeholder: "Eventuali informazioni aggiuntive...",
  deposit_modal_notice: "Dopo l'invio, il nostro team verificherà il pagamento e accrediterà il tuo account entro 5-30 minuti.",
  deposit_modal_confirm: "Conferma deposito",
  deposit_modal_submitting: "Invio in corso...",
  deposit_modal_err_fields: "Si prega di compilare tutti i campi richiesti",
  deposit_modal_err_submit: "Si è verificato un errore durante l'invio",
  deposit_modal_success: "Deposito richiesto con successo!",
  deposit_modal_err_plans: "Caricamento piani di deposito fallito",
  deposit_modal_err_wallets: "Caricamento metodi di pagamento fallito",
  deposit_modal_new_to_crypto: "New to crypto? Learn how to buy digital currency",
  deposit_modal_crypto_label: "Cripto",
  orders_insufficient_balance: "Insufficient Balance",
  orders_balance_gap_msg1: "Your current balance is not enough to complete this order.",
  orders_balance_gap_msg2_start: "Please add",
  orders_balance_gap_msg2_end: "to proceed and unlock your commission.",
  orders_btn_add_funds: "Add Funds",
  withdrawal_restricted_support: "Contact Support",
  deposit_modal_plan_description_hint: "Add the deposit for getting the order and earn the commission from order process",
};
